import React from "react";
import type { DeploymentSettingsPageProps } from "./SharedDeploymentSettingsPage";
import SharedDeploymentSettingsPage from "./SharedDeploymentSettingsPage";
export function DeploymentSettingsPage({ loaderData, gitRef }: DeploymentSettingsPageProps) {
    return <SharedDeploymentSettingsPage loaderData={loaderData} gitRef={gitRef}/>;
}
